import { UserContext } from '@/contexts/UserContextProvider';
import React, { useContext } from 'react';

const useUser = () => {

  const {isLogin, isAdmin, isOwner, isImposter, userID, expireDate, organisationID} = useContext(UserContext);

  return {
    isLogin,
    isAdmin,
    isOwner,
    isImposter,
    userID,
    organisationID,
    expireDate,
  };
};

export default useUser
